import { useCallback, useEffect, useState } from 'react';
import { pingApiBridge } from '../api/extensionClient';

export type BridgeStatus = 'checking' | 'connected' | 'missing';

export function useApiBridge() {
  const [status, setStatus] = useState<BridgeStatus>('checking');
  const [version, setVersion] = useState<string>();

  const check = useCallback(async () => {
    try {
      const result = await pingApiBridge();
      setVersion(result.version);
      setStatus('connected');
      return true;
    } catch {
      setStatus('missing');
      return false;
    }
  }, []);

  useEffect(() => {
    void check();
    const timer = window.setInterval(() => void check(), 15_000);
    return () => window.clearInterval(timer);
  }, [check]);

  return { status, version, check };
}
